module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp13_9016.faa918ff.png";